import { useMemo } from 'react';

import { useGetApiUserSettingsQuery } from 'applications/GSP/shared/api/gsp';
import { FALLBACK_LNG as DEFAULT_LOCALE } from 'shared/constants/translation';

import { EMPTY_LOCALE } from './constants';
import { useSupportedLocales, useSupportedBrowserLocale } from './hooks';

export const useDefaultLocale = () => {
  const { supportedLocaleIds, defaultLocale: schoolDefaultLocale } =
    useSupportedLocales();
  const browserLocale = useSupportedBrowserLocale();

  const selectedLocale = useGetApiUserSettingsQuery()?.data?.locale;

  return useMemo(() => {
    if (!schoolDefaultLocale) return EMPTY_LOCALE;

    const localeListPriority = [
      ...(selectedLocale ? [selectedLocale] : []),
      ...(browserLocale ? [browserLocale] : []),
      schoolDefaultLocale,
      DEFAULT_LOCALE,
    ];

    return (
      localeListPriority.find(locale => supportedLocaleIds.includes(locale)) ||
      ''
    );
  }, [browserLocale, schoolDefaultLocale, selectedLocale, supportedLocaleIds]);
};
